import { Routes } from '@angular/router';
import { PeopleAdminComponent } from './components/people-admin/people-admin.component';

export const PEOPLE_ROUTES: Routes = [{
	path: 'People', component: PeopleAdminComponent
}];
